import React, { useRef } from "react";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useOutsideClick from "../../hooks/useOutsideClick";
import { BsPersonFill, BsUpload } from "react-icons/bs";
import { userSignOut } from "../../actions/Auth";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

export default function SmallProfile({ classes }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const wrapperProfileRef = useRef(null);
  const firstName = localStorage.getItem("firstname");
  const lastName = localStorage.getItem("lastname");
  const [toggleDropdown, setToggleDropdown] =
    useOutsideClick(wrapperProfileRef);

  function handleClickProfile() {
    setToggleDropdown(!toggleDropdown);
  }

  return (
    <ul
      className={
        i18n.language === "en"
          ? classes.menuItemContainerLtr
          : classes.menuItemContainer
      }
    >
      <li
        className={toggleDropdown ? classes.menuItemActive : classes.menuItem}
        onClick={handleClickProfile}
      >
        <span
          style={{
            marginRight: 5,
            marginLeft: 10,
            fontSize: 10,
          }}
        >
          <h6 className={classes.profileTitle}>
            {!firstName || !lastName
              ? "نام کاربری"
              : firstName + " " + lastName}
          </h6>
        </span>
        <span>
          {toggleDropdown ? (
            <ExpandLessIcon className={classes.icons} fontSize="small" />
          ) : (
            <ExpandMoreIcon className={classes.icons} fontSize="small" />
          )}
        </span>
      </li>
      {toggleDropdown && (
        <span ref={wrapperProfileRef}>
          <li className={classes.dropdown}>
            <span
              className={
                i18n.language === "en" ? classes.listItemLtr : classes.listItem
              }
              style={{ color: "#1d1c22" }}
            >
              <p>{t("header.profile")}</p>
              <BsPersonFill style={{ fontSize: "20px", padding: 3 }} />
            </span>
          </li>

          <li
            onClick={() => {
              dispatch(userSignOut());
            }}
            className={classes.dropdown}
          >
            <span
              className={
                i18n.language === "en" ? classes.listItemLtr : classes.listItem
              }
              style={{ color: "#1d1c22" }}
            >
              <p>{t("header.exit")}</p>
              <BsUpload
                style={{
                  fontSize: "20px",
                  padding: 3,
                  transform: `rotate(90deg)`,
                }}
              />
            </span>
          </li>
        </span>
      )}
    </ul>
  );
}
